import { __rest } from "tslib";
import React from 'react';
import { SwitchCheckbox } from '@klarna/bubble-ui';
const SwitchCheckboxWrapper = (_a) => {
    var { label, value } = _a, props = __rest(_a, ["label", "value"]);
    return (React.createElement(SwitchCheckbox, Object.assign({ checked: value }, props), label));
};
export default SwitchCheckboxWrapper;
